import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux'

import PageScreen from '../../../components/organisms/Page/PageScreen'
import Paragraph from '../../../components/atoms/Paragraph/Paragraph'
import AppButton from '../../../components/atoms/AppButton/AppButton'
import { UI_BUTTON_TYPE } from '../../../components/atoms/AppButton/AppButtonProps'
import { AppLinks } from '../../../environment/app-links'
import analyticsService from '../../../service/analytics.service'
import { apphistory, AppState } from '../../../store'
import { PredefinedOfferDetailsModal, PredefinedOfferPageSingleOffer } from '../PredefinedOfferPage'
import { IPredefinedOfferDetails } from '../PredefinedOfferPageProps'
import usePredefinedOfferPageLogic from '../hooks/usePredefinedOfferPageLogic'
import useTextContents from '../../../hooks/useTextContents'
import { IPredefinedSingleOfferResponse, PREDEFINED_PERIODS_OFFER_LOGIC } from '../../../store/types'
import PredefinedPeriodButtons from '../../../components/molecules/PredefinedPeriodButtons/PredefinedPeriodButtons'

import '../PredefinedOfferPageStyles.scss'



/**
 * [ZAŁOŻENIE BIZNESOWE] - MECHANIZM PREDEFINIOWANYCH OKRESÓW POŻYCZKI
 * Strona z wyborem predefiniowanej oferty z przyciskami do wyboru rat. Dla każdej z predefiniowanych rat, dopasowana jest predefiniowana oferta 
 */
const PredefinedOfferPredefinedPeriodsPageContent = () => {
   const textContent = useTextContents()

   const { predefinedUserOffersObject } = useSelector((state: AppState) => state.offertState)
   const { currentSelectedPredefinedPeriod } = useSelector((state: AppState) => state.applicationState)
   const [currentSelectedPeriod, setCurrentSelectedPeriod] = useState<PREDEFINED_PERIODS_OFFER_LOGIC | undefined>(currentSelectedPredefinedPeriod)
   const [isContentLoading, setIsContentLoading] = useState<boolean>(false)

   useEffect(() => {
      setCurrentSelectedPeriod(currentSelectedPredefinedPeriod)
   }, [currentSelectedPredefinedPeriod])

   const currentSelectedPredefinedOffersData = (predefinedUserOffersObject !== undefined && currentSelectedPeriod !== undefined) ? predefinedUserOffersObject[currentSelectedPeriod] : undefined
   const HAS_NO_OFFERS = (currentSelectedPredefinedOffersData === undefined || currentSelectedPredefinedOffersData.length === 0)
   
   const { 
      currentSelectedOffer, isMenuOpen, ANALYTICS_EVENT_TYPES_NAMES, 
      handleOnOfferClick, handleSubmitPredefinedOffer, handleToggleMenuOpen,  
   } = usePredefinedOfferPageLogic({ predefinedOffersData: currentSelectedPredefinedOffersData })
   
   
   

   if(HAS_NO_OFFERS) {
      return null
   }

   
   return (
      <PageScreen title={{title: textContent('predefinedOfferPage.heading'), line: true}}>
         <div className='predefined-offer-page-container' id="predefined-offer-page-container">
            <Paragraph bold>Wybierz okres spłaty:</Paragraph>
            <PredefinedPeriodButtons 
               currentSelectedPeriod={currentSelectedPeriod} setCurrentSelectedPeriod={setCurrentSelectedPeriod}  
               isLoading={isContentLoading} setIsButtonLoading={setIsContentLoading} 
            />
            <Paragraph bold>Wybierz ofertę:</Paragraph>
            <div className='predefined-offer-page-offers-container'>
               {
                  currentSelectedPredefinedOffersData.map((singleOffer: IPredefinedSingleOfferResponse, index: number) => {
                     return (
                        <PredefinedOfferPageSingleOffer 
                           key={`predefined-single-offer-${index}`} 
                           textContent={textContent} 
                           handleOnOfferClick={handleOnOfferClick} {...singleOffer} 
                           isLoading={isContentLoading}
                        />
                     )
                  })
               }
            </div>
            <AppButton
               uiButtonType={UI_BUTTON_TYPE.PRIMARY_OUTLINE}
               onClick={async() => {
                  await analyticsService.createSingleAnalyticEvent(ANALYTICS_EVENT_TYPES_NAMES?.CustomUserOfferPageDisplayed)
                  apphistory.push(AppLinks.customOffer)
               }}>
               {textContent('buttons.predefinedOfferChooseCustomOffer')}
            </AppButton>
            {currentSelectedOffer !== undefined && (
               <PredefinedOfferDetailsModal
                  isMenuOpen={isMenuOpen}
                  isLoading={false}
                  setIsMenuOpen={handleToggleMenuOpen}
                  handleOnDialogConfirm={handleSubmitPredefinedOffer}
                  textContent={textContent}
                  {...currentSelectedOffer as IPredefinedOfferDetails} 
               />
            )}
         </div>
      </PageScreen>
   )
}

export default PredefinedOfferPredefinedPeriodsPageContent